import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type BeneficiaryIndicatorsFetchFailedAction = {
	type: 'BENEFICIARY_INDICATORS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): BeneficiaryIndicatorsFetchFailedAction => ({
	type: 'BENEFICIARY_INDICATORS_FETCH_FAILED',
	payload,
});
